export default __webpack_public_path__ + "static/media/tf-down.af3980f4.svg";